<div class="container-div">
        <div class="row justify-content-center py-4">
            <div class="col-md-8">
                <div class="d-flex justify-content-center" style="margin-bottom: 10px;">
                    <svg width="60" height="60" viewBox="0 0 87 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M43.9025 75.7621C52.5915 75.7621 60.9246 72.3104 67.0687 66.1664C73.2127 60.0223 76.6644 51.6892 76.6644 43.0002C76.6644 34.3112 73.2127 25.9781 67.0687 19.834C60.9246 13.69 52.5915 10.2383 43.9025 10.2383C35.2135 10.2383 26.8804 13.69 20.7364 19.834C14.5923 25.9781 11.1406 34.3112 11.1406 43.0002C11.1406 51.6892 14.5923 60.0223 20.7364 66.1664C26.8804 72.3104 35.2135 75.7621 43.9025 75.7621Z"
                            stroke="#B3261E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M33.6656 36.8575C35.9273 36.8575 37.7608 35.024 37.7608 32.7622C37.7608 30.5005 35.9273 28.667 33.6656 28.667C31.4038 28.667 29.5703 30.5005 29.5703 32.7622C29.5703 35.024 31.4038 36.8575 33.6656 36.8575Z"
                            fill="#B3261E" />
                        <path
                            d="M54.1421 36.8575C56.4039 36.8575 58.2374 35.024 58.2374 32.7622C58.2374 30.5005 56.4039 28.667 54.1421 28.667C51.8804 28.667 50.0469 30.5005 50.0469 32.7622C50.0469 35.024 51.8804 36.8575 54.1421 36.8575Z"
                            fill="#B3261E" />
                        <path
                            d="M31.6172 55.2862C34.0866 49.8272 38.1819 47.0957 43.9029 47.0957C49.6239 47.0957 53.7192 49.8272 56.1886 55.2862"
                            stroke="#B3261E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>


                </div>
                <!-- <p class="text-center fs-4 mb-0">Successful</p> -->
                <p class="text-center" style="word-wrap: break-word; line-height: normal;">{{data.errorMessage}}</p>

            </div>
        </div>
        <div class="close-btn" (click)="closeModal()">
            Dismiss
        </div>
</div>